var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow-1 flex-column d-flex justify-center align-center"},[_c('p',{staticClass:"text-h6"},[_vm._v("The page you are looking for does not exist")])])
}]

export { render, staticRenderFns }